import { Component, OnInit, Inject } from '@angular/core';
import { HarvestReportFormGroup } from './harvest-report-form-group';
import { FormControl } from '@angular/forms';
import { Crop } from '../../shared/services/crop.service';
import { ReportingFilterOptions, REPORTING_FILTER_OPTIONS } from '../services/reporting-filter-options.service';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { AlertService } from '../../shared/services/alert.service';
import { ReportingService } from '../services/reporting.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { AlphabeticalNamedSorter } from '../../shared/sort-methods';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-harvest-report-form',
  templateUrl: './harvest-report-form.component.html'
})
export class HarvestReportFormComponent implements OnInit {
  public rootForm: HarvestReportFormGroup;

  public get startDateFormControl(): FormControl {
    return this.rootForm.startDateFormControl;
  }
  
  public get endDateFormControl(): FormControl {
    return this.rootForm.endDateFormControl;
  }

  public get cropFormControl(): FormControl {
    return this.rootForm.cropFormControl;
  }

  public crops: Crop[] = [];

  constructor(@Inject(REPORTING_FILTER_OPTIONS) options: ReportingFilterOptions, 
  private loadingService: LoadingWrapperService, 
  private alertService: AlertService,
  private reportingService: ReportingService,
  private reportWriterService: FileSaverService) { 
    this.rootForm = new HarvestReportFormGroup();
    options.crops.subscribe(c => this.crops = c.sort(AlphabeticalNamedSorter));
  }

  ngOnInit() {
  }

  public generateReport(): void {
    this.loadingService.setMessage('Generating harvest report...');

    this.reportingService.getHarvestReport({
      cropId: this.cropFormControl.value,
      endDate: this.endDateFormControl.value,
      startDate: this.startDateFormControl.value
    })
    .pipe(finalize(() => this.loadingService.clearMessage()))
    .subscribe(
      file => this.reportWriterService.save(file),
      error => this.alertService.error('Error generating harvest report.'));
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/harvest-report-form/harvest-report-form.component.ts